import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'

const canUseGoogleSlideSyncV2 = (state, getters) => {
  return isFeatureEnabled(getters, 'google-slides-sync-general-api')
}

export default {
  canUseGoogleSlideSyncV2,
}
